import * as React from 'react';
import { DropdownMenu } from 'components/DropdownMenu';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IUserPreferences, IUserPreferencesAction } from 'models/user/userpreferences';
import { getUserPreferences, putUserPreferences } from 'modules/user/userpreferences';
import { IStore } from 'redux/IStore';
import { LoadingOverlayWrapper } from 'components';
const { connect } = require('react-redux');
require('./style.css');

interface IProps {
	userPreferences?: IUserPreferences;

	/* functions props */
	getUserPreferences?: () => IUserPreferencesAction;
	putUserPreferences?: (userPreferences: IUserPreferences) => IUserPreferencesAction;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		putUserPreferences: (form: IUserPreferences) => dispatch(putUserPreferences(form)),
		getUserPreferences: () => dispatch(getUserPreferences()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserActivitySettingsDropdownMenu extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.onActivityArticlesVisibleChange = this.onActivityArticlesVisibleChange.bind(this);
		this.onActivityCommentsVisibleChange = this.onActivityCommentsVisibleChange.bind(this);
		this.onActivityLikesVisibleChange = this.onActivityLikesVisibleChange.bind(this);
		this.onActivityStylesVisibleChange = this.onActivityStylesVisibleChange.bind(this);
		this.onActivityWishlistVisibleChange = this.onActivityWishlistVisibleChange.bind(this);
		this.onActivityFollowsVisibleChange = this.onActivityFollowsVisibleChange.bind(this);
		this.onActivityWardrobeItemsVisibleChange = this.onActivityWardrobeItemsVisibleChange.bind(this);
		this.onActivitOutfitsVisibleChange = this.onActivitOutfitsVisibleChange.bind(this);
	}

	public componentDidMount() {
		this.props.getUserPreferences();
	}

	private onActivityLikesVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityLikesVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityCommentsVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityCommentsVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityStylesVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityStylesVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityWishlistVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityWishlistVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityArticlesVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityArticlesVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityFollowsVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityFollowsVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivityWardrobeItemsVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityWardrobeItemsVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	private onActivitOutfitsVisibleChange(e) {
		const userPreferences = this.props.userPreferences;
		userPreferences.activityOutfitsVisible = e.target.checked;
		this.props.putUserPreferences(userPreferences);
	}

	public render() {
		const { userPreferences, t } = this.props;

		const likesChecked = userPreferences && userPreferences.activityLikesVisible;
		const commentsChecked = userPreferences && userPreferences.activityCommentsVisible;
		const stylesChecked = userPreferences && userPreferences.activityStylesVisible;
		const wishlistChecked = userPreferences && userPreferences.activityWishlistVisible;
		const articlesChecked = userPreferences && userPreferences.activityArticlesVisible;
		const followsChecked = userPreferences && userPreferences.activityFollowsVisible;
		const wardrobeItemsChecked = userPreferences && userPreferences.activityWardrobeItemsVisible;
		const outfitsChecked = userPreferences && userPreferences.activityOutfitsVisible;

		const showButton = (
			<span className="showClass">
				<img src={`${require('../../../Html/icons/eye-visible.svg')}`} />
				{t('DropdownMenus_UserActivitySettings_Button_Show')}
			</span>
		);
		const hideButton = (
			<span className="hideClass">
				<img src={`${require('../../../Html/icons/eye-novisible.svg')}`} />
				{t('DropdownMenus_UserActivitySettings_Button_Hide')}
			</span>
		);

		return (
			<div className="userActivitySettingsDropdownMenu">
				<DropdownMenu
					buttonText={t('DropdownMenus_UserActivitySettings_Button_Settings')}
					buttonIcon={<img src={require('containers/Html/icons/settings.svg')} />}
				>
					<LoadingOverlayWrapper
						active={userPreferences && userPreferences.isFetching}
						spinner={true}
						text={t('BSPortal_Common_Loading')}
						background="rgba(0, 0, 0, 0.1)"
					>
						<ul className="dropdownWrapper">
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Likes')}
								<label>
									<input
										type="checkbox"
										className={likesChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityLikesVisible"
										checked={likesChecked}
										onChange={this.onActivityLikesVisibleChange}
									/>
									{likesChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Comments')}
								<label>
									<input
										type="checkbox"
										className={commentsChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityCommentsVisible"
										checked={commentsChecked}
										onChange={this.onActivityCommentsVisibleChange}
									/>
									{commentsChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Styles')}
								<label>
									<input
										type="checkbox"
										className={stylesChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityStylesVisible"
										checked={stylesChecked}
										onChange={this.onActivityStylesVisibleChange}
									/>
									{stylesChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Wishlist')}
								<label>
									<input
										type="checkbox"
										className={wishlistChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityWishlistVisible"
										checked={wishlistChecked}
										onChange={this.onActivityWishlistVisibleChange}
									/>
									{wishlistChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Articles')}
								<label>
									<input
										type="checkbox"
										className={articlesChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityArticlesVisible"
										checked={articlesChecked}
										onChange={this.onActivityArticlesVisibleChange}
									/>
									{articlesChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Follows')}
								<label>
									<input
										type="checkbox"
										className={followsChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityFollowsVisible"
										checked={followsChecked}
										onChange={this.onActivityFollowsVisibleChange}
									/>
									{followsChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_WardrobeItems')}
								<label>
									<input
										type="checkbox"
										className={wardrobeItemsChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityWardrobeItemsVisible"
										checked={wardrobeItemsChecked}
										onChange={this.onActivityWardrobeItemsVisibleChange}
									/>
									{wardrobeItemsChecked ? showButton : hideButton}
								</label>
							</li>
							<li>
								{t('DropdownMenus_UserActivitySettings_Label_Outfits')}
								<label>
									<input
										type="checkbox"
										className={outfitsChecked ? 'eyenoShow' : 'eyeShow'}
										name="activityWardrobeItemsVisible"
										checked={outfitsChecked}
										onChange={this.onActivitOutfitsVisibleChange}
									/>
									{outfitsChecked ? showButton : hideButton}
								</label>
							</li>
						</ul>
					</LoadingOverlayWrapper>
				</DropdownMenu>
			</div>
		);
	}
}

export { UserActivitySettingsDropdownMenu };
